import type { AssetRopaReviewStatus } from 'config/api/ropaReviews/ropaReviews.types';

export type AssetRopaReviewFilters = {
  search: string;
  reviewStatus: '' | AssetRopaReviewStatus;
  assetTypeId: '' | number;
  operationalOwnerMembershipId: '' | number;
  warningState: '' | 'with_warnings' | 'no_warnings';
  dpiaState: '' | 'indicated' | 'required_unapproved' | 'none';
  sensitivePersonalData: '' | 'true' | 'false';
  thirdCountryProcessing: '' | 'true' | 'false';
};

export const DEFAULT_ASSET_ROPA_REVIEW_FILTERS: AssetRopaReviewFilters = {
  search: '',
  reviewStatus: '',
  assetTypeId: '',
  operationalOwnerMembershipId: '',
  warningState: '',
  dpiaState: '',
  sensitivePersonalData: '',
  thirdCountryProcessing: '',
};

export type AssetRopaReviewFilterOptions = {
  assetTypes: Array<{ id: number; name: string }>;
  operationalOwners: Array<{ id: number; name: string }>;
};
